import React from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import {Link} from "react-router-dom";
import moment from "moment";

import JwtClient from "./JwtClient";
import Logout from "./utils";
import Alert from "./Alert";

// SpeedX rejects a manifest with a single tracking number
const MIN_PARCELS = 2;

// Lists the SpeedX packages received by Velox and not manifested yet, the admin
// selects some or all of them and creates a SpeedX manifest.
export default class SpeedXManifestCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            errors: [], // why the backend or SpeedX refused the manifest
            packages: [],
            selected: {}, // package id -> true
            loading: true,
            submitting: false,
        };
    }

    render() {
        const selectedIDs = this.selectedIDs();
        const allSelected = this.state.packages.length > 0 && selectedIDs.length === this.state.packages.length;
        return (
            <Container>
                <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                    <h4 className="mb-0">New SpeedX Manifest</h4>
                    <Link to="/speedx-manifests">Back to SpeedX manifests</Link>
                </div>

                {this.state.alert ? <Alert>{this.state.alert}</Alert> : null}
                {this.state.errors.length > 0 ?
                    <Alert>
                        <ul className="mb-0">
                            {this.state.errors.map((e, i) => <li key={i}>{e}</li>)}
                        </ul>
                    </Alert> : null}

                {this.state.loading ?
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div> :
                    this.state.packages.length === 0 ? <p>No received unmanifested SpeedX packages</p> :
                        <div>
                            <div className="d-flex align-items-center mb-2">
                                <button
                                    className="btn btn-primary"
                                    onClick={this.createManifest}
                                    disabled={selectedIDs.length < MIN_PARCELS || this.state.submitting}
                                >
                                    {this.state.submitting ?
                                        <div className="spinner-border spinner-border-sm"></div> :
                                        <span>Manifest selected ({selectedIDs.length})</span>
                                    }
                                </button>
                                <span className="text-muted ml-3">
                                    {selectedIDs.length} of {this.state.packages.length} selected
                                </span>
                                <span className="text-muted ml-3">SpeedX needs at least {MIN_PARCELS} packages</span>
                            </div>
                            <Table>
                                <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={allSelected}
                                            onChange={() => this.selectAll(!allSelected)}
                                            disabled={this.state.submitting}
                                        />
                                    </th>
                                    <th>Tracking number</th>
                                    <th>HAWB</th>
                                    <th>User</th>
                                    <th>Created</th>
                                    <th>Received</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.packages.map(p => (
                                    <tr key={p.id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={!!this.state.selected[p.id]}
                                                onChange={() => this.toggle(p.id)}
                                                disabled={this.state.submitting}
                                            />
                                        </td>
                                        <td><Link to={'/packages/' + p.tracking_number}>{p.tracking_number}</Link></td>
                                        <td>{p.customs_hawb}</td>
                                        <td>{p.user_id}</td>
                                        <td>{moment(p.created_at).format('MM/DD/YY h:mm a')}</td>
                                        <td>{p.received_by_velox_at ? moment(p.received_by_velox_at).format('MM/DD/YY h:mm a') : ''}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>
                }
            </Container>
        )
    }

    selectedIDs = () => this.state.packages.filter(p => this.state.selected[p.id]).map(p => p.id);

    toggle = (id) => {
        this.setState(prevState => ({selected: {...prevState.selected, [id]: !prevState.selected[id]}}));
    };

    selectAll = (value) => {
        const selected = {};
        if (value) {
            this.state.packages.forEach(p => selected[p.id] = true);
        }
        this.setState({selected: selected});
    };

    componentDidMount() {
        this.getPackages();
    }

    getPackages() {
        this.setState({loading: true});
        JwtClient.get(`/api/v1/admin/speedx-packages/unmanifested`)
            .then(response => {
                this.setState({packages: response.data.packages, selected: {}});
            })
            .catch(err => {
                if (err.response) {
                    if (err.response.status === 401) {
                        Logout();
                    }
                    this.setState({alert: 'Error on fetching, status: ' + err.response.status});
                } else {
                    this.setState({alert: JSON.stringify(err)});
                }
            })
            .finally(() => {
                this.setState({loading: false});
            })
    }

    createManifest = () => {
        this.setState({submitting: true, alert: '', errors: []});
        // SpeedX may take a while, the default timeout is 60s
        JwtClient.post(`/api/v1/admin/speedx-manifests`, {package_ids: this.selectedIDs()}, {timeout: 120000})
            .then(() => {
                this.props.history.push('/speedx-manifests');
            })
            .catch(err => {
                if (!err.response) {
                    this.setState({alert: JSON.stringify(err), submitting: false});
                    return
                }
                const status = err.response.status;
                if (status === 401) {
                    Logout();
                    return
                }
                const errors = err.response.data && err.response.data.errors;
                if (errors && errors.length > 0) {
                    this.setState({errors: errors, submitting: false});
                    return
                }
                this.setState({alert: 'Error on creating manifest, status: ' + status, submitting: false});
            })
    };
}
